module.exports = __webpack_public_path__ + "assets/img/default-portrait.edf12171.svg";